import { useCallback } from 'react';
import { useIntl } from 'react-intl';

type TranslationValues = Record<string, string | number>;

export const useTranslation = () => {
  const intl = useIntl();

  const t = useCallback(
    (id: string, values?: TranslationValues) => intl.formatMessage({ id }, values),
    [intl.formatMessage],
  );

  return { t, ...intl };
};
